import React, { useState } from 'react'; 
import "../Accordions/Accordions.css";


function Accordion({ title, content }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="accordion">
      <div className="accordionHeader" onClick={toggleAccordion}>
        <h3>{title}</h3>
        <span>{isOpen ? '-' : '+'}</span>
      </div>
      <div className={`accordionContent ${isOpen ? 'open' : ''}`}>
        {isOpen && <p>{content}</p>}
      </div>
    </div>
  );
}

export default Accordion;
